// src/components/MapView.jsx
import React, { useState } from "react";
import { CAT_COLOR } from "../data/events";

export default function MapView({ events, filter, onPinClick }) {
  const [, setZoom] = useState(1);
  const filtered = filter === "all" ? events : events.filter((e) => e.cat === filter);

  return (
    <div style={{ position: "relative", margin: "8px 16px 0", borderRadius: 14, overflow: "hidden", border: "0.5px solid rgba(0,0,0,0.12)", background: "#E8EEF4", height: 310 }}>
      <style>{`@keyframes mapPulse{0%{transform:translate(-50%,-50%) scale(1);opacity:0.45}100%{transform:translate(-50%,-50%) scale(2.6);opacity:0}}`}</style>

      {/* Street grid */}
      {[{top:"30%",h:9},{top:"57%",h:7},{top:"78%",h:6}].map((r,i) => (
        <div key={i} style={{ position:"absolute", top:r.top, left:0, right:0, height:r.h, background:"#fff", opacity:0.75 }}/>
      ))}
      {[{left:"24%",w:8},{left:"54%",w:7},{left:"78%",w:6}].map((c,i) => (
        <div key={i} style={{ position:"absolute", left:c.left, top:0, bottom:0, width:c.w, background:"#fff", opacity:0.75 }}/>
      ))}
      {/* City blocks */}
      {[
        {t:"5%",l:"3%",w:"18%",h:"22%"},{t:"5%",l:"29%",w:"22%",h:"22%"},
        {t:"5%",l:"59%",w:"15%",h:"22%"},{t:"5%",l:"82%",w:"14%",h:"22%",bg:"#C8DBBF"},
        {t:"36%",l:"3%",w:"18%",h:"17%"},{t:"36%",l:"29%",w:"22%",h:"17%"},
        {t:"36%",l:"59%",w:"15%",h:"17%"},{t:"36%",l:"82%",w:"14%",h:"17%"},
        {t:"61%",l:"3%",w:"18%",h:"13%"},{t:"61%",l:"29%",w:"22%",h:"13%"},
        {t:"61%",l:"59%",w:"15%",h:"13%"},{t:"61%",l:"82%",w:"14%",h:"13%"},
        {t:"82%",l:"3%",w:"18%",h:"14%"},{t:"82%",l:"29%",w:"22%",h:"14%"},
        {t:"82%",l:"59%",w:"20%",h:"14%",bg:"#B8D4E8"},{t:"82%",l:"82%",w:"14%",h:"14%"},
      ].map((b,i) => (
        <div key={i} style={{ position:"absolute", top:b.t, left:b.l, width:b.w, height:b.h, background:b.bg||"#D6DDE6", borderRadius:3 }}/>
      ))}

      {/* User location */}
      <div style={{ position:"absolute", top:"48%", left:"44%", width:28, height:28, borderRadius:"50%", background:"#7F77DD", opacity:0.15, transform:"translate(-50%,-50%)" }}/>
      <div style={{ position:"absolute", top:"48%", left:"44%", width:12, height:12, borderRadius:"50%", background:"#7F77DD", border:"2.5px solid #fff", transform:"translate(-50%,-50%)", zIndex:15 }}/>

      {/* Event pins */}
      {filtered.map((ev) => (
        <div
          key={ev.id}
          onClick={() => onPinClick(ev)}
          style={{ position:"absolute", left:`${ev.lng}%`, top:`${ev.lat}%`, transform:"translate(-50%,-100%)", cursor:"pointer", zIndex:10, display:"flex", flexDirection:"column", alignItems:"center" }}
        >
          {ev.live && (
            <div style={{ position:"absolute", top:-4, left:"50%", width:20, height:20, borderRadius:"50%", border:`2px solid ${ev.color}`, animation:"mapPulse 2s infinite" }}/>
          )}
          <div style={{ width:24, height:24, borderRadius:"50% 50% 50% 0", transform:"rotate(-45deg)", background:ev.color, border:"2px solid #fff", display:"flex", alignItems:"center", justifyContent:"center" }}>
            <span style={{ transform:"rotate(45deg)", fontSize:9, color:"#fff" }}>●</span>
          </div>
          <span style={{ fontSize:8, background:"#fff", border:"0.5px solid rgba(0,0,0,0.12)", borderRadius:20, padding:"1px 5px", color:ev.color, whiteSpace:"nowrap", marginTop:1, maxWidth:60, overflow:"hidden", textOverflow:"ellipsis" }}>
            {ev.title.split(" ").slice(0, 2).join(" ")}
          </span>
        </div>
      ))}

      {/* Legend */}
      <div style={{ position:"absolute", bottom:8, left:8, background:"#fff", borderRadius:9, padding:"6px 9px", border:"0.5px solid rgba(0,0,0,0.1)" }}>
        {Object.entries(CAT_COLOR).slice(0,5).map(([cat, col]) => (
          <div key={cat} style={{ display:"flex", alignItems:"center", gap:4, fontSize:9, color:"#666", marginBottom:2 }}>
            <div style={{ width:7, height:7, borderRadius:"50%", background:col }}/>
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </div>
        ))}
      </div>

      {/* Zoom controls */}
      <div style={{ position:"absolute", top:8, right:8, display:"flex", flexDirection:"column", gap:3 }}>
        {["+","−"].map((s) => (
          <button key={s} onClick={() => setZoom(z => s === "+" ? Math.min(3, z + 0.3) : Math.max(0.5, z - 0.3))}
            style={{ width:26, height:26, background:"#fff", border:"0.5px solid rgba(0,0,0,0.12)", borderRadius:7, cursor:"pointer", fontSize:15, fontWeight:500, display:"flex", alignItems:"center", justifyContent:"center" }}>
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}
